import React from "react";
import { useKeycloak } from "@react-keycloak/web";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./components/Home";
import ScheduleSub from "./components/ScheduleSub";
import RequestSub from "./components/RequestSub";
import RescheduleCanceledJob from "./components/RescheduleCanceledJob";
import SubstituteForm from "./components/SubstituteForm";
import ManageGroups from "./components/ManageGroups";
import TermsOfService from "./components/TermsOfService";
import ViewSubRequest from "./components/ViewSubRequest";
import ViewMySubRequest from "./components/ViewMySubRequest";
import ViewMySubRequestFancy from "./components/ViewMySubRequestFancy";
import ViewTeacherSubRequest from "./components/ViewTeacherSubRequest";


import ProtectedRoute from "./ProtectedRoute";
import PowerUserRoute from "./PowerUserRoute";

function App() {
    const { keycloak } = useKeycloak();

    if (!keycloak.authenticated) return <div>Loading...</div>;

    return (
    <>
    <div className="App">
        <Router>
            <Routes>
                <Route path="/" element={<RequestSub />} />
                <Route path="/requestsub" element={<ProtectedRoute><RequestSub /></ProtectedRoute>} />
                <Route path="/termsofservice" element={<ProtectedRoute><TermsOfService /></ProtectedRoute>} />
                <Route path="/home" element={<ProtectedRoute><Home /></ProtectedRoute>} />
                <Route path="/subform" element={<PowerUserRoute><SubstituteForm /></PowerUserRoute>} />
                <Route path="/schedulesub" element={<ProtectedRoute><ScheduleSub /></ProtectedRoute>} />
                <Route path="/requestsub" element={<ProtectedRoute><RequestSub /></ProtectedRoute>} />
                <Route path="/reschedulecanceledjob" element={<ProtectedRoute><RescheduleCanceledJob /></ProtectedRoute>} />
                <Route path="/viewsubrequest" element={<ProtectedRoute><ViewSubRequest /></ProtectedRoute>} />
                <Route path="/viewmyjobs" element={<ProtectedRoute><ViewMySubRequestFancy /></ProtectedRoute>} />
                <Route path="/viewteacherjobs" element={<PowerUserRoute><ViewTeacherSubRequest /></PowerUserRoute>} />
                <Route path="/viewmyjobsfancy" element={<ProtectedRoute><ViewMySubRequestFancy /></ProtectedRoute>} />
                <Route path="/groups" element={<PowerUserRoute><ManageGroups /></PowerUserRoute>} />

                {/* Other routes */}
            </Routes>
        </Router>
    </div>


    </>
    );
}

export default App;
